/** Shared Figma dialog header styles (Select Plan + AI Results modals). */
export const ASSESSMENT_IMPACT_DIALOG_TITLE_ROW_SX = {
  display: "flex",
  alignItems: "center",
  gap: "12px",
  boxSizing: "border-box",
  height: 81,
  minHeight: 81,
  maxHeight: 81,
  m: 0,
  p: 0,
  px: "24px",
  py: "16px",
  flexShrink: 0,
  borderBottom: "1px solid #F2F2F2",
} as const;

export const ASSESSMENT_IMPACT_DIALOG_TITLE_TEXT_SX = {
  fontFamily: '"Nunito Sans", sans-serif',
  fontWeight: 700,
  fontSize: 20,
  lineHeight: "25px",
  letterSpacing: 0,
  textTransform: "capitalize" as const,
  color: "#0D0D0D",
} as const;

export const ASSESSMENT_IMPACT_DIALOG_TITLE_DESC_SX = {
  fontFamily: '"Nunito Sans", sans-serif',
  fontWeight: 400,
  fontSize: 14,
  lineHeight: "20px",
  letterSpacing: 0,
  color: "#595959",
} as const;

export { DIALOG_CLOSE_BUTTON_SX as ASSESSMENT_IMPACT_DIALOG_TITLE_CLOSE_BUTTON_SX } from "../../constants/dialogCloseButtonStyles";

/** Figma content inset; header border → body uses {@link ASSESSMENT_IMPACT_DIALOG_BODY_TOP_OFFSET_SX}. */
export const ASSESSMENT_IMPACT_DIALOG_CONTENT_SX = {
  boxSizing: "border-box",
  padding: "0 32px 32px 32px",
  display: "flex",
  flexDirection: "column",
  gap: 2,
  overflow: "visible",
  "&.MuiDialogContent-root": {
    paddingTop: 0,
    paddingRight: "32px",
    paddingBottom: "32px",
    paddingLeft: "32px",
  },
} as const;

/** Figma — distance from header bottom border to table / cards. */
export const ASSESSMENT_IMPACT_DIALOG_BODY_TOP_OFFSET_SX = {
  mt: "24px",
  flexShrink: 0,
} as const;
